module.exports = __webpack_public_path__ + "static/media/colombia_icon.590e245c.png";